import params from "../../../setup/config/params";
import Marketing from "../index";
import CreateEdit from "../CreateEdit";
import ViewEvent from '../components/ViewEvent.js'
import Subscribers from "../Subscribers";
import NewsletterSettings from "../NewsletterSettings";
import Settings from "../Email/EmailSettings.jsx";
import { IMAGE_SOURCE_PATH } from "../../../setup/config/env";
import { defaultImage } from '../../common/Sidebar';

export function getImageSource(image = defaultImage) {
    return `${IMAGE_SOURCE_PATH}${image}`;
}

const routes = {
    editEvent: {
        path: (type, id) => `/messaging/${type}/edit/${id}`,
        component: CreateEdit,
        auth: true,
        role: params.user.roles.admin.key,
        module: "marketing",
        subModule: "messaging",
        action: "",
    },
    viewEvent: {
        path: (type, id) => `/messaging/${type}/view/${id}`,
        component: ViewEvent,
        auth: true,
        role: params.user.roles.admin.key,
        module: "marketing",
        subModule: "messaging",
        action: "canView",
    },
    messaging: {
        path: "/messaging",
        component: Marketing,
        auth: true,
        role: params.user.roles.admin.key,
        module: "marketing",
        subModule: "messaging",
        action: "canView",
    },
    subscribers: {
        path: (page = 1) => `/newsletter-subscribers/${page}`,
        activePath: "/newsletter-subscribers",
        component: Subscribers,
        auth: true,
        role: params.user.roles.admin.key,
        module: "marketing",
        subModule: "newsletter",
        action: "canView",
        requiresResourceEnabled: true,
    },
    newsletterSettings: {
        path: "/newsletter-settings",
        component: NewsletterSettings,
        auth: true,
        role: params.user.roles.admin.key,
        module: "marketing",
        subModule: "newsletter",
        action: "canView",
        requiresResourceEnabled: true,
    },
    marketingSettings: {
        path: "/messaging/settings",
        component: Settings,
        auth: true,
        role: params.user.roles.admin.key,
        module: "marketing",
        subModule: "messaging",
        action: "canView",
    },
};

export default routes;